import {createSelector} from '@reduxjs/toolkit'
import { 
    APPLICATION_STATUS_PENDING_PAYMENT,
    LICENCE_STATUS_EXPIRED,
    LICENCE_STATUS_NEW,
    LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION,
    LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION
} from '../../app/constants'
import { IsDateInFuture, IsDateYearCurrentYear, IsTodayWithinRange } from '../../app/utils'
import { isRenewalTypeApplication } from '../slice/applicationsUtils'

export const mraPrincipalBrokerSelector = createSelector(
    [state => state.additionalApplications], 
    ({agentApplications}) => {
        const principalBrokerApplications = agentApplications.filter(app => (
            app.licencingSubType === LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION 
                    || app.licencingSubType === LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION))
        return {
            principalBrokerApplication : principalBrokerApplications?.length > 0 ? principalBrokerApplications[0] : null
        }
    }
)

export const mraPrincipalBrokerRenewableStatusSelect = createSelector(
    [mraPrincipalBrokerSelector,
    (state) => state.primaryAgencyApplication?.licenceTypeDetails],
    ({ principalBrokerApplication }, licenceTypeDetails) => {
        if(!principalBrokerApplication) {
            return {
                isAgentRenewalEnable: false
            }
        }

        // const licenceTypeDetails = licenceTypeDetails;
        const licenceType = licenceTypeDetails?.businessLicenceStatusList?.[0];
        const renewalStartDate = licenceType?.renewalStartDate;
        const renewalEndDate = licenceType?.renewalGraceDate ?? licenceType?.renewalEndDate;

        const licenceExpiry = principalBrokerApplication?.endDate ?? 0;

        let isAgentRenewalEnable =
            renewalStartDate && renewalEndDate
                ? IsTodayWithinRange(renewalStartDate, renewalEndDate) &&
                IsDateYearCurrentYear(licenceExpiry) &&
                IsDateInFuture(licenceExpiry)
                : false;
        // case : licence has expired (post expiry date) but still in grace period
        const isExpiredInGracePeriod =
            principalBrokerApplication.licenceStatus === LICENCE_STATUS_EXPIRED && IsDateInFuture(renewalEndDate);
        const isDraftInGracePeriod =
            isRenewalTypeApplication(principalBrokerApplication) &&
            principalBrokerApplication.applicationStatus === APPLICATION_STATUS_PENDING_PAYMENT &&
            IsDateInFuture(renewalEndDate);
        isAgentRenewalEnable = isAgentRenewalEnable || isExpiredInGracePeriod || isDraftInGracePeriod;

        return {
            isAgentRenewalEnable
        };
    }
);

export const mraMainAgentChangeApplicationSelector = createSelector(
    [state => state.additionalApplications], 
    ({agentApplications}) => {
        const mainAgentDraftApplications = agentApplications.filter(app => (
            app.licencingSubType === LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION 
                && app.applicationStatus === APPLICATION_STATUS_PENDING_PAYMENT
                && app.licenceStatus === LICENCE_STATUS_NEW
            ))
        return {
            mainAgentChangeApplication : mainAgentDraftApplications?.length > 0 ? mainAgentDraftApplications[0] : null
        }
    }
)